<template>
  <div class="inventoryTransferSendDetail">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <h2 style="margin-right: 20px;">{{ data.transfer.id ? '编辑' : '新增' }}调拨（调出）</h2>
        <el-button-group>
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button type="info" @click="clear()">清空</el-button>
          <el-button type="primary" v-if="!data.transfer.inDate" @click="send()" :loading="show.saving">保存</el-button>
        </el-button-group>
        <el-text type="danger" v-if="data.transfer.inDate"> * 本车已调入，请在调拨（调入）中修改</el-text>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="调出日期">
            <el-date-picker style="width: 100%;" v-model="data.transfer.outDate" type="date" @change="handleChangeOutDate()" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="data.transfer.id" label="调入状态">
            <el-text v-if="!data.transfer.inDate">运输中</el-text>
            <el-text v-if="data.transfer.inDate">已调入</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调出仓储">
            <el-select v-model="data.transfer.outStorage" filterable @change="loadInventoryList()">
              <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调入仓储">
            <el-select v-model="data.transfer.inStorage" filterable>
              <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="运输公司">
            <el-select v-model="data.transfer.transportCompany" filterable>
              <el-option v-for='transportCompanyItem in show.transportCompanyList' :key="transportCompanyItem.id" :label="transportCompanyItem.value" :value="transportCompanyItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌号">
            <el-input v-model="data.transfer.truckNumber" :max="100" />
          </el-form-item>
        </el-col>
        <el-divider content-position="left">数量</el-divider>
        <el-col :span="6">
          <el-form-item label="重车数量">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.outQuantityGross" @change="computeOutQuantity()" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="皮重数量">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.outQuantityTare" @change="computeOutQuantity()" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="涨吨数量">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.outExpandedQuantity" @change="computeOutQuantity()" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-tooltip effect="dark" content="重车数量-皮重数量-涨吨数量，保存后即按配比扣减调出仓库存" placement="bottom">
            <el-form-item label="调出数量">
              <el-input-number disabled style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.outQuantity" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-col :span="12">
          <el-tooltip effect="dark" content="本次调拨新发生的运费单价，调入方按到货数量计价" placement="bottom">
            <el-form-item label="调拨运费单价">
              <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.transferTransportPrice" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-col :span="24">
          <el-form-item label="销售品名">
            <el-select v-model="data.transfer.customNote" @change="handleCustomNoteSelect" filterable clearable :placeholder="data.transfer.outDate ? '不必填，选了会自动带出配比' : '请先选择调出日期'">
              <el-option v-for='customNote in show.customNoteList' :key="customNote.id" :label="customNote.customNote" :value="customNote.customNote" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="配比">
            <el-table :data="data.transfer.mixDetailList" border height="210px">
              <el-table-column label="" width="80" header-align="center" align="center">
                <template #default="scope">
                  <el-link type="danger" @click="delRow(scope.row)" v-if="scope.row.product">删除</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="product" label="煤矿品名" header-align="center">
                <template #default="scope">
                  <el-select style="width: 100%;" v-model="scope.row.product" filterable @change="checkRowProduct(scope.row)">
                    <el-option v-for='productItem in show.productList' :key="productItem.id" :label="productItem.value" :value="productItem.value" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="mixNumber" label="占比" header-align="center">
                <template #default="scope">
                  <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="scope.row.mixNumber" @change="computeMix()" />
                </template>
              </el-table-column>
              <el-table-column prop="outQuantity" label="调出数量" header-align="center">
                <template #default="scope">
                  <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="scope.row.outQuantity" @change="changeMixQuantity()" />
                </template>
              </el-table-column>
              <el-table-column label="调出仓库存" width="140" header-align="center" align="right">
                <template #default="scope">
                  <el-text v-if="scope.row.product" :type="inventoryQuantity(scope.row.product) < scope.row.outQuantity ? 'danger' : ''">
                    {{ math.formatNumber(inventoryQuantity(scope.row.product)) }}
                  </el-text>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注信息">
            <el-input v-model="data.transfer.note" :max="100" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-text type="info">
              调出方保存后<b>只扣减调出仓库存</b>，调入仓的库存要等调入方在【调拨（调入）】里填完到货信息才增加。
              各品名的调出成本按<b>保存那一刻</b>调出仓的加权平均成本快照。
            </el-text>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script setup>
import { reactive, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const show = reactive({
  saving: false,
  storageList: [],
  productList: [],
  transportCompanyList: [],
  customNoteList: [],
  // 调出仓各品名的当前库存，key 是品名
  inventoryMap: {},
})
const pageParam = cache.getObject(cache.keys.pageParam + "inventoryTransferSendDetail")
const data = reactive({
  transfer: pageParam ? JSON.parse(JSON.stringify(pageParam)) : { mixDetailList: [] }
})
if (!data.transfer.mixDetailList) {
  data.transfer.mixDetailList = []
}
/** 配比表格：任何一次改动都刷新，始终只保留一个位于最下方的空行（空行不显示删除按钮） */
const refreshBlankRow = () => {
  const list = data.transfer.mixDetailList
  for (let i = list.length - 1; i >= 0; i--) {
    if (!list[i].product) {
      list.splice(i, 1)
    }
  }
  list.push({})
}
refreshBlankRow()

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'product' } }).then(res => {
  show.productList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'transportCompany' } }).then(res => {
  show.transportCompanyList = res.dictList
})

/** 调出仓的全部库存，配比表格里逐行提示够不够扣 */
const loadInventoryList = () => {
  show.inventoryMap = {}
  if (!data.transfer.outStorage) {
    return
  }
  api.get('/backend/inventory/list', { params: { storage: data.transfer.outStorage } }).then(res => {
    const map = {}
    for (const item of res.list) {
      map[item.product] = item
    }
    show.inventoryMap = map
  })
}
loadInventoryList()

const inventoryQuantity = (product) => {
  const item = show.inventoryMap[product]
  return item ? item.quantity : 0
}

const handleChangeOutDate = () => {
  // 重新查询配比
  show.customNoteList = []
  if (data.transfer.outDate) {
    const useDate = util.parseTime(data.transfer.outDate, '{y}-{m}-{d}')
    api.get('/backend/customNoteToMix/all', { params: { useDate } }).then(res => {
      show.customNoteList = res.list
    })
  }
  // 清除已选择的配比
  data.transfer.customNote = null
  data.transfer.mixDetailList = [{}]
}
if (data.transfer.outDate) {
  const useDate = util.parseTime(data.transfer.outDate, '{y}-{m}-{d}')
  api.get('/backend/customNoteToMix/all', { params: { useDate } }).then(res => {
    show.customNoteList = res.list
  })
}

/** 选了销售品名就把配比带出来，不选也可以直接填配比 */
const handleCustomNoteSelect = (customNoteString) => {
  if (!customNoteString) {
    return
  }
  const customNote = show.customNoteList.filter(x => x.customNote == customNoteString)[0]
  if (!customNote) {
    return
  }
  data.transfer.mixDetailList = customNote.mixList.map(item => {
    return { product: item.product, mixNumber: item.mixNumber }
  })
  refreshBlankRow()
  computeMix()
}

const delRow = (row) => {
  data.transfer.mixDetailList = data.transfer.mixDetailList.filter(item => item.product != row.product)
  refreshBlankRow()
  computeMix()
}

const checkRowProduct = (row) => {
  const l1 = data.transfer.mixDetailList.length
  const l2 = data.transfer.mixDetailList.filter(item => item.product != row.product).length
  if (l1 != l2 + 1) {
    ElMessage.error("煤矿品名重复")
    row.product = null
  }
  // 改已有行也走这里：以前只在 else 里 push 空行，改一次就多一行空行
  refreshBlankRow()
}

/** 调出数量 = 重车 - 皮重 - 涨吨（调出环节还没有退车） */
const computeOutQuantity = () => {
  data.transfer.outQuantity = math.plus(data.transfer.outQuantityGross || 0, -(data.transfer.outQuantityTare || 0), -(data.transfer.outExpandedQuantity || 0))
  computeMix()
}

/** 按占比把调出数量摊到各品名，尾差落在最后一行 */
const computeMix = () => {
  if (data.transfer.mixDetailList == null) {
    return
  }
  const mixDetailList = data.transfer.mixDetailList.filter(x => x.product)
  if (data.transfer.outQuantity && mixDetailList.length > 0) {
    let mixNumber = 0
    for (const i in mixDetailList) {
      mixNumber = math.plus(mixNumber, mixDetailList[i].mixNumber || 0)
    }
    if (mixNumber > 0) {
      let sumQuantity = 0
      for (const i in mixDetailList) {
        const mixDetailItem = mixDetailList[i]
        if (!mixDetailItem.mixNumber) {
          mixDetailItem.outQuantity = 0
        } else {
          if (i < mixDetailList.length - 1) {
            mixDetailItem.outQuantity = math.halfUp(data.transfer.outQuantity * mixDetailItem.mixNumber / mixNumber, 2)
          } else {
            mixDetailItem.outQuantity = math.plus(data.transfer.outQuantity, -sumQuantity)
          }
          sumQuantity = math.plus(sumQuantity, mixDetailItem.outQuantity)
        }
      }
      ElMessage.success('已自动配比数量')
    }
  }
}

/** 手填了分品名数量时，占比反过来跟着数量走 */
const changeMixQuantity = () => {
  for (const mixIndex in data.transfer.mixDetailList) {
    const mixDetail = data.transfer.mixDetailList[mixIndex]
    if (mixDetail.outQuantity && mixDetail.product) {
      mixDetail.mixNumber = mixDetail.outQuantity
    }
  }
}

const clear = () => {
  data.transfer = { mixDetailList: [{}] }
  show.inventoryMap = {}
}

const send = () => {
  if (show.saving) {
    return
  }
  const transfer = data.transfer
  if (!transfer.outDate) {
    ElMessage.error('请选择调出日期')
    return
  }
  if (!transfer.outStorage || !transfer.inStorage) {
    ElMessage.error('请选择调出仓储与调入仓储')
    return
  }
  if (!transfer.transportCompany) {
    ElMessage.error('请选择运输公司')
    return
  }
  if (!transfer.truckNumber) {
    ElMessage.error('请填写车牌号')
    return
  }
  if (!(transfer.outQuantity > 0)) {
    ElMessage.error('调出数量必须大于0')
    return
  }
  const mixDetailList = transfer.mixDetailList.filter(item => item.product && item.outQuantity)
  if (mixDetailList.length == 0) {
    ElMessage.error('请填写配比')
    return
  }
  let sumOutQuantityMix = 0
  mixDetailList.forEach(mixDetail => {
    sumOutQuantityMix = math.plus(sumOutQuantityMix, mixDetail.outQuantity)
  })
  if (sumOutQuantityMix != transfer.outQuantity) {
    ElMessage.error("配比数量不等于调出数量，请重新填写配比数量")
    return
  }
  const param = { id: transfer.id }
  param.outDate = util.parseTime(transfer.outDate, '{y}-{m}-{d}')
  param.outStorage = transfer.outStorage
  param.inStorage = transfer.inStorage
  param.transportCompany = transfer.transportCompany
  param.truckNumber = transfer.truckNumber
  param.customNote = transfer.customNote
  param.note = transfer.note
  param.outQuantityGross = transfer.outQuantityGross || 0
  param.outQuantityTare = transfer.outQuantityTare || 0
  param.outExpandedQuantity = transfer.outExpandedQuantity || 0
  param.outQuantityInitial = transfer.outQuantity
  param.outQuantity = transfer.outQuantity
  param.transferTransportPrice = transfer.transferTransportPrice || 0
  param.mixDetailList = mixDetailList.map(item => {
    return {
      product: item.product,
      mixNumber: item.mixNumber,
      outQuantity: item.outQuantity,
    }
  })
  show.saving = true
  api.post('/backend/inventoryTransfer/send', param).then(() => {
    ElMessage.success('保存成功')
    router.go(-1)
  }).finally(() => {
    show.saving = false
  })
}

// 关闭页面生命周期
onUnmounted(() => {
  if (!data.transfer.id) {
    cache.setObject(cache.keys.pageCache + "inventoryTransferSendDetail", data.transfer)
  }
})
if (!data.transfer.id) {
  const transfer = cache.getObject(cache.keys.pageCache + "inventoryTransferSendDetail")
  if (transfer) {
    data.transfer = transfer
    loadInventoryList()
    ElMessage.success('已快捷填写上次填写的信息')
  }
}
</script>

<style lang="less">
.inventoryTransferSendDetail {
  margin: auto;
  max-width: 900px;
}
</style>
